import { makeStyles } from '@material-ui/core/styles';

export const useViewHistoryStyles = makeStyles(theme => ({
  history: {
    flexGrow: 1,
    padding: `${theme.spacing(4)}px ${theme.spacing(0)}px`,
    overflow: 'hidden'
  }
}));
